import { stripToDay } from "../../utils/date";
import { isEmpty } from "./RawValueRules";

function getCultureSeparatorOrDefault(culture: string): string {
    const defaultCultureSeparator = ".";

    if (culture) {
        const currentCultureSeparator = Globalize.cultures[culture].numberFormat["."];

        return currentCultureSeparator || defaultCultureSeparator;
    }

    return defaultCultureSeparator;
}

function getNumberOfDecimalPlaces(num: string, culture?: string): number {
    const selectorTemplate = "(?:\\{separator}(\\d+))?(?:[eE]([+-]?\\d+))?$";

    const selectorString = selectorTemplate.replace("{separator}", getCultureSeparatorOrDefault(culture));
    const selector = new RegExp(selectorString);

    const match = ("" + num).match(selector);
    if (!match) {
        return 0;
    }
    return Math.max(
        0,
        // Number of digits right of decimal point.
        (match[1] ? match[1].length : 0) -
            // Adjust for scientific notation.
            (match[2] ? +match[2] : 0)
    );
}

export function valueIsAtLeast<TValue>(value: TValue, atLeast: TValue): boolean {
    return isEmpty(value) || value >= atLeast;
}

export function dateValueIsAtLeast<TValue>(value: Date, atLeast: Date): boolean {
    if (!value) {return true} // value should be checked by Reqired
    return atLeast && value.getTime() >= stripToDay(atLeast).getTime();
}

export function valueIsAtMost<TValue>(value: TValue, atMost: TValue): boolean {
    return isEmpty(value) || isEmpty(atMost) || value <= atMost;
}

export function valueIsMoreThan<TValue>(value: TValue, moreThan: TValue): boolean {
    return isEmpty(value) || value > moreThan;
}

export function valueIsLessThan<TValue>(value: TValue, lessThan: TValue): boolean {
    return isEmpty(value) || value < lessThan;
}

export function hasLessDecimalPlacesThan(value: string, numberOfDecimalPlaces: number, culture?: string): boolean {
    return numberOfDecimalPlaces >= getNumberOfDecimalPlaces(value, culture);
}
